import React from 'react';
import email from '../../components/email.json';

export default function OptoutInsideBoxFr() {
  return (
    <main>
      <h4>{email.optout.landing.ui.body.section2.Header.fr}</h4>
      <hr />
      <p>
        {email.optout.landing.ui.body.section2.text1.fr}
      </p>
      <p className="noteText">
        <strong>{email.optout.landing.ui.body.section2.note.start.fr}</strong>
        {email.optout.landing.ui.body.section2.note.text.fr}
      </p>
      <p>
        {email.optout.landing.ui.body.section3.text1.fr}
        <a href={'mailto:' + email.optout.landing.ui.body.section3.supportemail.eng}>
          <span>{email.optout.landing.ui.body.section3.supportemail.eng}</span>
        </a>
        {email.optout.landing.ui.body.section3.or.fr}
        {email.optout.landing.ui.body.section3.phone.fr}
      </p>
    </main>
  );
}
